
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { MessageItemProps } from ".";
import { loading, find } from "store/message";

interface ApiMessageFindByIdInputProps {
    id: number;
}

type ApiMessageFindOutputProps = OutputBaseProps<{ item: MessageItemProps; }, ApiMessageFindByIdInputProps>;

export const apiMessageFindById = async (data: ApiMessageFindByIdInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiMessageFindOutputProps>(`/api/message/${data.id}`))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(find({ data: res.data.item }));
    }
    return res;
};


interface ApiMessageFindByCodeInputProps {
    code: string;
}

export const apiMessageFindByCode = async (data: ApiMessageFindByCodeInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiMessageFindOutputProps>(`/api/message/code/${data.code}`))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(find({ data: res.data.item }));
    }
    return res;
};